import { NgTemplateOutlet } from '@angular/common';
import { AfterContentInit, Component, ContentChildren, input, output, QueryList, TemplateRef, ViewChild } from '@angular/core';
import { MatStep, MatStepLabel, MatStepper } from '@angular/material/stepper';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import * as enTranslations from './assets/i18n/en-lang.json';

interface StepContext {
  controls: {
    next: () => void;
    previous: () => void;
    finish: () => void;
  };
}

@Component({
  selector: 'spx-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  imports: [MatStepper, MatStep, NgTemplateOutlet, MatStepLabel, TranslatePipe],
  host: { '[class.show-header]': 'showHeader()' },
})
export class StepperComponent implements AfterContentInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ContentChildren(TemplateRef) stepTemplates!: QueryList<TemplateRef<StepContext>>;
  protected finished = output<void>();
  protected steps: TemplateRef<StepContext>[] = [];
  protected disableNavigation = input<boolean>(false);
  protected linear = input<boolean>(false);
  protected stepLabels = input<string[]>([]);
  protected showHeader = input<boolean>(false);

  constructor(private translateService: TranslateService) {
    this.translateService.setTranslation('en', enTranslations, true);
  }

  ngAfterContentInit() {
    this.steps = this.stepTemplates.toArray();
  }

  protected goToStep(index: number): void {
    if (this.linear()) {
      const targetStep = this.stepper.steps.get(index);
      const isCurrent = index === this.stepper.selectedIndex;
      const isCompleted = targetStep?.completed ?? false;
      if (!isCurrent && !isCompleted) {
        return;
      }
    }
    this.stepper.selectedIndex = index;
  }

  protected next(): void {
    if (this.stepper.selectedIndex < this.steps.length - 1) {
      if (this.linear()) {
        const currentStep = this.stepper.steps.get(this.stepper.selectedIndex);
        if (currentStep) {
          currentStep.completed = true;
        }
      }
      this.stepper.selectedIndex++;
    }
  }

  protected previous(): void {
    if (this.stepper.selectedIndex > 0) {
      this.stepper.selectedIndex--;
    }
  }

  protected finish(): void {
    this.finished.emit();
  }
}
